import { useCallback } from 'react';
import { useProjectionExternalAssetSettings, useProjectionInternalAssetSettings } from '../../../../api';
import type { ItemSettingsDto, PanelSettingsDto } from '../../../../api/generated/client';

export const useTotalSelectedBankableAssets = () => {
    const { data: internalAssets, isSuccess: isInternalAssetsSuccess } = useProjectionInternalAssetSettings();
    const { data: externalAssets, isSuccess: isExternalAssetsSuccess } = useProjectionExternalAssetSettings();

    const getSelectedAssets = useCallback(
        (assets?: PanelSettingsDto) => {
            if (isInternalAssetsSuccess && isExternalAssetsSuccess) {
                if (!assets?.enabled) {
                    return 0;
                }

                return assets.itemsSettings.filter((asset: ItemSettingsDto) => asset.enabled).reduce((acc, asset: ItemSettingsDto) => acc + asset.amount!, 0);
            } else {
                return 0;
            }
        },
        [isInternalAssetsSuccess, isExternalAssetsSuccess],
    );

    return getSelectedAssets(internalAssets) + getSelectedAssets(externalAssets);
};
